import { defineStore } from 'pinia'
import type { ShowcaseRequestCreate } from '~/models/showcase-requests'

const API_ENDPOINT = '/showcase-requests'

export const useShowcaseRequests = defineStore('showcase-requests', () => {
  const baseURL = useRuntimeConfig().public.gatewayApi

  async function createShowcaseRequest(
    showcaseRequestData: ShowcaseRequestCreate
  ): Promise<void> {
    await useAuthFetch<{ data: any }>(API_ENDPOINT, {
      method: 'POST',
      baseURL,
      body: showcaseRequestData,
    })
  }

  return {
    createShowcaseRequest,
  }
})
